import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import { grey, red } from '@mui/material/colors'
import '@fontsource/exo'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/300.css'

const themeLight = createTheme({
  palette: {
    primary: {
      main: red[900],
      contrastText: '#fff',
    },
    secondary: {
      main: grey[900],
      contrastText: '#fff',
    },
    mode: 'light',
  },
  typography: {
    fontFamily: ['Roboto', 'sans-serif'].join(','),
    fontDisplay: 'swap',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      mobile: 0,
      tablet: 640,
      laptop: 1024,
      desktop: 1200,
    },
  },
})
export const lightTheme = responsiveFontSizes(themeLight)

const themeDark = createTheme({
  palette: {
    primary: {
      main: red[900],
      contrastText: '#fff',
    },
    secondary: {
      main: grey[900],
      contrastText: '#fff',
    },
    mode: 'dark',
  },
  typography: {
    fontFamily: ['Exo', 'sans-serif'].join(','),
    fontDisplay: 'swap',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      mobile: 0,
      tablet: 640,
      laptop: 1024,
      desktop: 1200,
    },
  },
})
export const darkTheme = responsiveFontSizes(themeDark)
